import AppText from "@common/component/AppText";
import { ColumnType } from "@common/component/InventoryTable";
import { carDetailsToString, withOpacity } from "@common/helper";
import { THEME_COLORS } from "@common/themes";
import moment from "moment";
import { StyleSheet, View } from "react-native";
import { InventoryListingItem } from "../apiService";
import { IconButton } from "@mui/material";
import { History } from "@mui/icons-material";

const columnData=({
  onClickHistoryIcon,
}: {
  onClickHistoryIcon: (row: InventoryListingItem) => void;
}): ColumnType<InventoryListingItem>[] => [
  {
    name: "LEAD ID",
    component: ({ row }) => {
      const leadId = row.lead.id;

      return (
        <View>
          <AppText allowTextCopy fontFamily="semibold">
            {leadId}
          </AppText>
        </View>
      );
    },
    label: "",
  },
  {
    name: "CAR DETAILS",
    component: ({ row }) => {
      const carReg = row.car_details.registration_no;
      const carDetails = carDetailsToString(row.car_details);

      return (
        <View style={styles.rowGap2}>
          <AppText fontFamily="semibold">{carReg}</AppText>
          <AppText numberOfLines={1} addToolTip fontFamily="regular" fontSize={12} color={THEME_COLORS.sideMenuGrey}>
            {carDetails}
          </AppText>
        </View>
      );
    },
    label: "",
  },
  {
    name: "DISPATCHED ON",
    component: ({ row }) => {
      const createdAt = moment(row.lead.moved_to_dispatch_at);

      const relativeTimestamp = createdAt.fromNow();
      const since = "since " + createdAt.format("Do MMM 'YY, h:mm A");

      return (
        <View>
          <AppText fontFamily="semibold">{relativeTimestamp}</AppText>
          <AppText addToolTip fontFamily="regular" fontSize={12} color={THEME_COLORS.sideMenuGrey}>
            {since}
          </AppText>
        </View>
      );
    },
    label: "moved_to_dispatch_at",
    sortable: true,
  },
  {
    name: "TECH/INSP",
    component: ({ row }) => {
      const techOrInsp = row.technician_or_inspector;

      return (
        <View>
          <AppText addToolTip fontFamily="regular">
            {techOrInsp.trim() || "--"}
          </AppText>
        </View>
      );
    },
    label: "",
  },
  {
    name: "STATUS UPDATE SINCE",
    component: ({ row }) => {
      const updatedAt = moment(row.last_status_updated_at);

      const relativeTimestamp = updatedAt.fromNow();
      const since = updatedAt.format("Do MMM 'YY, h:mm A");

      return (
        <View>
          <AppText fontFamily="semibold">{relativeTimestamp}</AppText>
          <AppText addToolTip fontFamily="regular" fontSize={12} color={THEME_COLORS.sideMenuGrey}>
            {since}
          </AppText>
        </View>
      );
    },
    label: "last_status_updated_at",
    sortable: true,
  },
  {
    name: "STATUS",
    component: ({ row }) => {
      const status = row.status.name;
      const statusColor = row.status.colour_coding;
      const updatedAt = moment(row.last_status_updated_at).format("Do MMM 'YY, h:mm A");
      const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        event.stopPropagation();
        onClickHistoryIcon?.(row);
      };
      return (
        <View style={{ flexDirection: 'row',gap:5, alignItems: "center", rowGap: 4 }}>
          <View style={{rowGap:4, justifyContent:'space-between', alignItems:'flex-start'}}>
            <View
              style={{
                width: "auto",
                borderRadius: 5,
                paddingVertical: 4,
                paddingHorizontal: 12,
                backgroundColor: withOpacity(statusColor, 0.3),
              }}
            >
              <AppText fontFamily="bold" fontSize={12} color={statusColor} style={{ textAlign: "center" }}>
                {status}
              </AppText>
            </View>
            <AppText fontFamily="regular" fontSize={12} color={THEME_COLORS.sideMenuGrey} style={{ textAlign: "center" }}>
              Updated: {updatedAt}
            </AppText>
          </View>
          <IconButton onClick={handleClick} size="small">
            <History
              sx={{
                color: THEME_COLORS.purple,
                backgroundColor: withOpacity("#7D7D7D", 0.08),
                border: `8px solid transparent`,
                borderRadius: 999,
              }}
            />
          </IconButton>
        </View>
      );
    },
    label: "",
  },
];

export { columnData };

const styles = StyleSheet.create({
  rowGap2: {
    gap: 2,
  },
});
